import type { Directive } from "vue";

// 定义事件处理函数类型
type ContextMenuHandler = (e: MouseEvent) => void;

const disableTableContextMenu: Directive = {
	mounted(el: HTMLElement) {
		// 创建事件处理函数
		const handler: ContextMenuHandler = (e) => {
			e.preventDefault(); // 阻止右键菜单
			// 可选：添加自定义提示（如需要）
			// ElMessage.warning('表格禁止右键操作！')
		};

		// 将处理函数存储到元素上，以便在卸载时移除
		(el as any).__disableContextMenuHandler = handler;

		// 监听表格元素的contextmenu事件
		el.addEventListener("contextmenu", handler);
	},
	unmounted(el: HTMLElement) {
		// 组件卸载时移除监听，避免内存泄漏
		const handler = (el as any).__disableContextMenuHandler as ContextMenuHandler | undefined;
		if (handler) {
			el.removeEventListener("contextmenu", handler);
			delete (el as any).__disableContextMenuHandler;
		}
	}
};

export default disableTableContextMenu;
